import {TranslateService} from '@ngx-translate/core';

export class CalendarView {
  constructor(protected translate: TranslateService) {
  }

  protected getDayColorAndLabel(workcycle, date: string): any {
    const workCycleDay = workcycle.find(item => item.attributes.date === date);
    const label = this.getLabel(workCycleDay);
    return {
      textColor: workCycleDay ? workCycleDay.textColor : '',
      color: workCycleDay ? workCycleDay.color : '',
      label,
      type: workCycleDay ? workCycleDay.attributes.typeTransId : ''
    };
  }

  private getLabel(workCycleDay): string {
    if (workCycleDay) {
      const attributes = workCycleDay.attributes;
      const isPartialTime = ['OPE', 'WOR'].includes(attributes.typeTransId) && attributes.hoursWorked === 0;
      if (isPartialTime) {
        return this.translate.instant('PAYROLL_PREPARE.day_not_worked');
      }
      return this.translate.instant(attributes.activityTransId);
    }
    return '';
  }
}
